export interface CookieConsentPreferences {
  necessary: boolean;      // Always true & locked (Cloudflare Turnstile, security, essential operations)
  analytics: boolean;      // Google Analytics (GA4) traffic, page views, and interactions
  preferences: boolean;    // User preferences & functional site settings
}

export interface CookieConsentState {
  hasInteracted: boolean;
  preferences: CookieConsentPreferences;
  timestamp: string | null;
}

export const DEFAULT_PREFERENCES: CookieConsentPreferences = {
  necessary: true,
  analytics: false,
  preferences: false,
};

export const ACCEPTED_ALL_PREFERENCES: CookieConsentPreferences = {
  necessary: true,
  analytics: true,
  preferences: true,
};

export const REJECTED_ALL_PREFERENCES: CookieConsentPreferences = {
  necessary: true,
  analytics: false,
  preferences: false,
};

export const COOKIE_CONSENT_STORAGE_KEY = 'service_now_cookie_consent_v1';
